export function RouteName({GRoute}) {
  return (
    <span style={{
      display: 'inline-block',
      padding: '.3rem',
      marginRight: '.3rem',
      minWidth: '3rem',
      color: '#' + GRoute.route_text_color,
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: '#' + GRoute.route_text_color,
      backgroundColor: '#' + GRoute.route_color,
      textDecoration: (GRoute.suspended) ? 'line-through red solid 2px' : undefined,
      textAlign: 'center',
      opacity: (GRoute.suspended) ? '0.5' : '1',
    }}>
      {
        (typeof GRoute.route_short_name !== "string" || String(GRoute.route_short_name).trim().length === 0 ) ? (
          <>{ GRoute.route_long_name }</>
        ) : (
          <b>{ GRoute.route_short_name }</b>
        )
      }
    </span>
  )
}